import actionTypes from '../actions/types';

const TRADES_LIMIT = 80;

export const INITIAL_STATE = {
  trades: {},
};

export const handleUpdateTradesData = (state, { symbol, data }) => {
  const batchSize = data.length;
  if (!batchSize) return state;
  const newState = { ...state, trades: { ...(state.trades || {}) } };
  let list = newState.trades[symbol] = state.trades[symbol] || [];
  if (list && list.some(({ a }) => a === data[0].a)) {
    if (__DEV__) console.warn('Got trade behind last trade id. ignoring.', data[0].a);
    return state;
  }
  list = newState.trades[symbol] = data.reverse().concat(newState.trades[symbol]); // must be new
  if (list.length > TRADES_LIMIT) {
    list.length = TRADES_LIMIT; // chop one off the end
  }
  // used in TradingDataProvider#shouldComponentUpdate
  newState.trades[symbol].__lastBatchSize__ = batchSize;
  return newState; // trigger update
};

export const handleClearTradesData = (state, { symbol }) => (
  { ...state, trades: { ...state.trades, [symbol]: [] } }
);

export const reducer = (state, action) => {
  switch (action.type) {
    // web socket actions
    case actionTypes.CLEAR_TRADES_DATA:
      return handleClearTradesData(state, action);
    case actionTypes.SET_TRADES_DATA:
      state = handleClearTradesData(state, action);
      return handleUpdateTradesData(state, action);
    default:
      return state;
  }
};
